// eslint-disable-next-line import/prefer-default-export
export const TAILLE_PJ_LIMITE = 50 * 1024 * 1024;
